<template lang="html">
  <div class="create-profile-wrapper">
    <div class="form-progress-wrap edit-profile academic-info-wrap">
      <BaseLoading  opaque :spinning="collegeLoading">
        <div class="container">
          <div class="steps-content">
            <div class="general-form-wrap academic-info-wrap box-wrapper">
              <div class="academic-form-wrap">
                <FormModel
                  :model="resource"
                  ref="form"
                  @submit.prevent.native="handleFormSubmit"
                  class="basic-information-form-wrapper"
                  :rules="validationRules"
                >
                  <div class="academic-info">
                    <div class="heading">
                      <h2 class="form-title">Academic Information</h2>
                    </div>
                    <a-row :gutter="32">
                      <a-col :sm="24">
                        <div class="ant-col ant-form-item-label">
                          <label title="Academic Specialities" class="ant-form-item-tmp-required"
                            >Academic Specialities</label
                          >
                          <h5 class="temp-message">Adding academic specialties to your college profile will help interested players find your college easily. Please contact admin to add academic specialties for your college</h5>
                        </div>
                        <!-- <BaseTaxonomySelect
                          resource="academicSpeciality"
                          placeholder="Select Academic Specialities"
                          type="Academic Specialities"
                          label="Academic Specialities"
                          class="grid-item-3"
                          mode="multiple"
                          :value="resource.academicSpecitialitiesIds"
                          name="academicSpeciality"
                          @change="
                            value =>
                              handleFormValueChange(
                                value,
                                'academicSpecitialitiesIds'
                              )
                          "
                        /> -->
                      </a-col>
                      <a-col :sm="24">
                        <BaseFormInput
                          :value="resource.scholarshipRequirement"
                          label="Scholarship Requirement"
                          placeholder="Scholarship Requirement"
                          @change="
                            event =>
                              handleFormValueChange(
                                event.target.value,
                                'scholarshipRequirement'
                              )
                          "
                          name="scholarshipRequirement"
                          class="grid-item-1 custom-height"
                          :height="100"
                          type="textarea"
                        />
                      </a-col>
                      <a-col :sm="12">
                        <BaseTaxonomySelect
                          resource="collegeGpa"
                          placeholder="Enter GPA Required"
                          type="College GPA"
                          name="gpaRequired"
                          label="GPA Required"
                          class="grid-item-2"
                          :value="resource.gpaRequiredId"
                          @change="
                            value =>
                              handleFormValueChange(value, 'gpaRequiredId')
                          "
                        />
                      </a-col>
                      <a-col :sm="12">
                        <BaseTaxonomySelect
                          resource="division"
                          placeholder="Select Division"
                          type="Division"
                          label="College Division"
                          class="grid-item-4"
                          name="division"
                          :value="resource.divisionId"
                          @change="
                            value => handleFormValueChange(value, 'divisionId')
                          "
                        />
                      </a-col>
                    </a-row>
                    <div class="margined-content">
                      <BaseButton
                        type="primary"
                        class="next-button"
                        html-type="submit"
                        :loading="collegeLoading"
                      >
                        Submit
                      </BaseButton>
                    </div>
                  </div>
                </FormModel>
              </div>
            </div>
          </div>
        </div>
      </BaseLoading>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { FormModel } from "ant-design-vue";
import { College } from "@/models";

const STORE_KEY = "collegeStore";

export default {
  data() {
    return {
      resource: new College()
    };
  },
  components: {
    FormModel
  },
  mounted() {
    this.$store.dispatch(`${STORE_KEY}/getCollege`, {
      id: localStorage["college-id"]
    });
    let label = $("label[title|='Academic Specialities']");
    label[0].classList.add("ant-form-item-required");
  },
  computed: {
    ...mapGetters({
      college: `${STORE_KEY}/college`,
      collegeLoading: `${STORE_KEY}/collegeLoading`
    }),
    academicSpecialityClass() {
      let label = $("label[title|='Academic Specialities']");
      return label[0] && label[0].classList;
    },
    validationRules() {
      return {
        ...College.academicValidation,
        academicSpeciality: [
          {
            required: _.isEmpty(
              this.resource && this.resource.academicSpecitialitiesIds
            ),
            message: "Academic Specialities is required",
            type: "array",
            trigger: "change"
          }
        ]
      };
    }
  },
  methods: {
    handleFormValueChange(value, key) {
      this.resource = new College({ ...this.resource, [key]: value });
    },
    async handleFormSubmit() {
      let data = {
        id: this.resource.id,
        scholarshipRequirement: this.resource.scholarshipRequirement,
        gpaRequired: this.resource.gpaRequiredId,
        division: this.resource.divisionId,
        academicSpecialities: this.resource.academicSpecitialitiesIds,
        slug: "collegeprofile"
      };
      if (!data.gpaRequired || data.gpaRequired === "-")
        delete data.gpaRequired;
      this.$refs.form.validate(async valid => {
        if (valid) {
          await this.$store.dispatch(`${STORE_KEY}/updateCollege`, data);
          await this.$store.dispatch(`${STORE_KEY}/getCollege`, {
            id: localStorage["college-id"]
          });
        }
      });
    }
  },
  watch: {
    academicSpecialityClass(newVal, _) {
      let label = $("label[title|='Academic Specialities']");
      if (label[0].classList.includes("ant-form-item-required")) {
        return;
      }
      label[0].classList.add("ant-form-item-required");
    },
    college(newVal, _) {
      this.resource = new College(newVal);
    }
  }
};
</script>

<style lang="sass">
.custom-height
  .cust-form-input
    height: 20rem !important;
</style>
